import React from 'react'
import styles from '../styles/work.css'
import { motion } from 'framer-motion'

const Project = ({img, title, link, github}) => {
  return(
      <motion.div
      initial={{opacity: 0, scale: 0}}
          whileInView={{opacity: 1, scale:1}}
          transition={{type: "just",duration: 0.5}}
      className='project'>
          <img alt='project-image' className='pro-img' src={img}/>
          <div className="img-text">
              <p className='caption'>{title}</p>
              { github ? <a className='button' target={"_blank"} href={link}>{"Visit Github >"}</a> : link !== null ? <a className='button' target={"_blank"} href={link}>{"Visit Website >"}</a> : ''}
              
          </div> 
  
      </motion.div>
    )
}

export default Project